import styled from 'styled-components';

export const StyledHeroWrapper = styled.div`
  max-height: ${({ theme }) => theme._ui.homePanel.maxHeightHero};
  background-color: ${({ theme }) => theme.background.medium};
  display: flex;
  flex-wrap: wrap;
  padding: ${({ theme }) =>
    `0 ${theme.spacing['2Xl']} ${theme.spacing['2Xl']} ${theme.spacing['2Xl']}`};

  @media (max-width: ${({ theme }) => theme.breakpoint.sm}) {
    top: 64px;
  }
`;

export const StyledLeftContent = styled.div`
  color: ${({ theme }) => theme.brand.primary};
  font-size: 3rem;
  height: 3rem;
  width: 3rem;
`;

export const StyledRightContent = styled.div`
  flex: 1;
  padding-left: ${({ theme }) => theme.spacing['xl']};
`;
